import React, { Component } from "react";
import { RouterProvider } from "react-router-dom";
import Router from "./Router";
import "antd/dist/reset.css";


export default class App extends Component {
	render() {
		return (
			<RouterProvider router={Router} />
		);
	}
}
